import { useAuth } from '@/app/AuthContext.jsx';

// Permission gates over the real `permissions` array from the active org's
// membership (populated by validate-token via AuthContext). Single source of
// truth for permission checks — page-level gates compose these instead of
// re-reading `permissions` themselves.

/** `true` when the active org grants `permission`. */
export function useCan(permission) {
  const { permissions } = useAuth();
  return Array.isArray(permissions) && permissions.includes(permission);
}

/** `true` when the active org grants ANY of `perms`. */
export function useCanAny(perms) {
  const { permissions } = useAuth();
  if (!Array.isArray(permissions)) return false;
  return perms.some((p) => permissions.includes(p));
}
